import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { Button, Flex } from "@chakra-ui/react";
import { useContext, useRef, useState } from "react";
import { useMap } from "react-map-gl/maplibre";

import { MapDeckGl } from "@nens/deck-gl";

import { useMapStyle } from "@/hooks/use-map-style";
import { ProjectConfigurationContext } from "@/pages/main-page";

import { useDrawPolygon } from "../hooks/use-draw-polygon";

export function MainMap() {
  const { mainMap } = useMap();
  const { location, clearPolygon } = useContext(ProjectConfigurationContext);
  const mapStyle = useMapStyle();

  const [dragging, setDragging] = useState(false);
  const [mouseLocation, setMouseLocation] = useState<[number, number]>([0, 0]);

  const { layer, onMapClick } = useDrawPolygon({ mouseLocation });

  const dontCallRef = useRef(0);

  if (!mapStyle) return null;

  return (
    <MapDeckGl
      mapProps={{
        mapStyle,
        initialViewState: {
          longitude: 5.4612108,
          latitude: 52,
          zoom: 7,
        },
        onMouseMove: (e) => {
          // Don't need to update if not drawing
          if (!onMapClick) return;
          // Handle mouse move gets called way too often so this slows it down a bit
          if (dontCallRef.current) return dontCallRef.current--;
          dontCallRef.current += 2;
          setMouseLocation([e.lngLat.lng, e.lngLat.lat]);
        },
      }}
      deckGlProps={{
        layers: [layer],
        onClick: onMapClick,
        onDragStart: () => setDragging(true),
        onDragEnd: () => setDragging(false),
        getCursor: ({ isHovering }: { isHovering: boolean }) => {
          const cursorStyle = isHovering
            ? "pointer"
            : !location
            ? "crosshair"
            : dragging
            ? "grabbing"
            : "grab";

          if (mainMap) mainMap.getCanvas().style.cursor = cursorStyle;
          return cursorStyle;
        },
      }}
      id="mainMap"
    >
      <Flex
        zIndex={999}
        bg="white"
        position="absolute"
        bottom={4}
        left="50%"
        transform="translateX(-50%)"
      >
        <Button isDisabled={!!location} variant="secondary" onClick={clearPolygon} w="fit-content">
          <EditIcon />
        </Button>
        <Button isDisabled={!location} variant="danger" onClick={clearPolygon} w="fit-content">
          <DeleteIcon />
        </Button>
      </Flex>
    </MapDeckGl>
  );
}
